"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Span = exports.Input = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../style/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Container = exports.Container = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__Container",
  componentId: "bufferapp-ui__sc-139z72o-0"
})(["display:flex;"]);
const Wrapper = exports.Wrapper = /*#__PURE__*/_styledComponents.default.label.withConfig({
  displayName: "style__Wrapper",
  componentId: "bufferapp-ui__sc-139z72o-1"
})(["display:flex;margin-left:8px;justify-content:center;align-items:center;"]);
const Span = exports.Span = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "style__Span",
  componentId: "bufferapp-ui__sc-139z72o-2"
})(["position:relative;cursor:pointer;display:inline-block;width:32px;height:16px;background-color:", ";border-radius:20px;transition:all 0.3s;&::after{content:'';position:absolute;width:14px;height:14px;border-radius:100px;background-color:", ";top:1px;left:1px;transition:all 0.3s;}"], _colors.gray, _colors.white);
const Input = exports.Input = /*#__PURE__*/_styledComponents.default.input.withConfig({
  displayName: "style__Input",
  componentId: "bufferapp-ui__sc-139z72o-3"
})(["position:absolute;pointer-events:none;width:32px;height:16px;margin-left:3px;opacity:0;&:checked + ", "{background:", ";&::after{content:'';display:block;border-radius:100px;width:14px;height:14px;margin-left:16px;transition:0.2s;}}&:focus + ", "{box-shadow:0px 0px 0px 2px ", ";outline:none;transition-duration:0.1s;transition-timing-function:ease-in;}&:disabled + ", "{cursor:not-allowed;filter:grayscale(100%);opacity:0.6;&:after{box-shadow:none;}}"], Span, _colors.blue, Span, _colors.blueLighter, Span);